// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__eJ3kY","head":"Table_head__2YZMw","col":"Table_col__2IUcm"};